import { useEffect, useRef } from 'react'
import { useMutationConsentPreferences } from '@/features/account/services/Preferences/mutations'
import { useUser } from '@/features/account/services/User/hooks'
import { MembershipPlanType } from '@/features/account/services/MembershipPlan/types'
import { getTranscendConsentPurposes } from '@/lib/transcend/utils'
import { trackSegmentConsentPreferenceUpdated } from '@/features/shared/analytics/transcend'
import { trackLoginCompleted } from '@/features/shared/analytics/users'
import { loginCompletedTriggerCookieName } from '@shared/constants/auth'
import ClientCookies from 'js-cookie'

export const useHandleLoginCompletion = () => {
  const user = useUser()
  const { id: userId, subscription } = user ?? {}
  const { mutate: updateConsentPreferences } = useMutationConsentPreferences()

  const hasRanLoginCheckRef = useRef(false)

  useEffect(() => {
    if (!userId || hasRanLoginCheckRef.current) return

    // The login completed cookie is set to '1' in the auth0 afterCallback handler
    // within src/features/shared/serverUtils/auth/handlers.ts upon successful login.
    // "1" is just an explicit arbitrary value to indicate that login has completed.
    if (ClientCookies.get(loginCompletedTriggerCookieName) === '1') {
      // remove the cookie once this is handled so it doesn't trigger the tracking events again
      ClientCookies.remove(loginCompletedTriggerCookieName)

      hasRanLoginCheckRef.current = true

      trackLoginCompleted('authv2', subscription?.type === MembershipPlanType.CIRCLE_360)

      // consent purposes can potentially be null if the user has never set their preferences before
      // or if there are no purposes defined. in either case, we don't need to update anything on login.
      const consentPurposes = getTranscendConsentPurposes()
      if (consentPurposes) {
        updateConsentPreferences({ userId, purposes: consentPurposes })
        trackSegmentConsentPreferenceUpdated()
      }
    }
  }, [userId, subscription, updateConsentPreferences])
}
